<template>
    <ul class="searchresults" v-if="results.length > 0">
      <li v-for="result in results"
          :key="result.id"
          @click="selectResult(result)"
          @keyup:enter="selectResult(result)"><span>{{ setResultDisplayFormat(result) }}</span></li>
    </ul>
</template>

<script>

export default {
  name: 'SearchResults',
  components: {

  },
  props: {
    results: {
      required: true,
    },
    searchType: {
      required: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {

  },
  methods: {
    setResultDisplayFormat(result) {
      if (this.searchType == 'suburb') {
        // console.log(this.searchType);
        return `${result.suburb}, ${result.state} ${result.postcode}`;
      }

      if (this.searchType == 'address') {
        return `${result.address}`;
      }
    },
    selectResult(selectedResult) {
      this.$emit('selectedResult', selectedResult);
    },


  },
};
</script>

<style lang="scss" scoped>
  ul {
    @apply ut-overflow-auto ut-absolute ut-w-full;
    border: 1px solid #ccc;
    max-height: 218px;
    border-radius: 0 0 4px 4px;
    background-color: #FFFFFF;
    margin-top: -3px;

    li{
      @apply ut-py-1 ut-px-3 ut-cursor-pointer;
      font-size: 14px;
      letter-spacing: 0.26px;
      line-height: 24px;
      color: rgba(46,52,59,0.78);

      &:hover {
        background-color: rgba(78,	182,	72, 0.2);
      }
    }

  }


</style>
